module.exports = __webpack_public_path__ + "static/media/GDocsDraftPrivacyNotice_ID.8e97568f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GDocsDraftPrivacyNotice_ID.pdf
// module id = 694
// module chunks = 4